import Menu from "./components/Menu";
import ListPassage from "./pages/ListPassage/Page";
import SignInPage from "./pages/SignIn";
import SignUpPage from "./pages/SignUp";
import Account from "./pages/Account";
import AccountChange from "./pages/AccountChange";
import HelpPage from "./pages/Help";
import HelpNewPage from "./pages/HelpNew";
import { WelcomePage } from "./pages/Welcome";
import { RecoverPage } from "./pages/Recover";
import { CarsPage } from "./pages/Cars";
import { CarPage } from "./pages/Car";

import PassageDetail from "./pages/PassageDetail";
import NewPassage from "./pages/NewPassage";

import React, { useState, Fragment } from "react";
import { IonApp, IonRouterOutlet, IonSplitPane } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Route, Redirect } from "react-router-dom";
import { ApolloProvider } from "@apollo/react-hooks";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";

import "./theme/custom.css";

import "./App.css";

import { App as AppInterface } from "./interfaces/app";
import { AppContext, injectContext } from "./base/AppContext";

import Client from "./services/apollo";
import { useAppHandlers } from "./base/useAppHandlers";

const AppMain = () => {
  const [selectedPage] = useState("");

  return (
    <Fragment>
      <Menu selectedPage={selectedPage} />
    </Fragment>
  );
};

const AppValid: React.FC<AppInterface> = ({ isAuth, isWelCome }) => {
  if (isAuth) {
    if (!isWelCome) {
      return <Redirect to="/page/welcome" />;
    }
    return <Redirect to="/page/passages" />;
  }
  if (!isAuth) {
    return <Redirect to="/sign-in" />;
  }

  return null;
};

const AppAuthRedirect = injectContext(AppValid);

const App: React.FC = () => {
  const { appState } = useAppHandlers();
  return (
    <IonApp>
      <IonReactRouter>
        <AppContext.Provider value={appState}>
          <ApolloProvider client={Client}>
            <IonSplitPane contentId="main">
              <AppMain />
              <IonRouterOutlet id="main">
                <Route
                  path="/sign-in"
                  render={() => <SignInPage />}
                  exact={true}
                />

                <Route exact path="/sign-up" render={() => <SignUpPage />} />

                <Route
                  exact
                  path="/page/welcome"
                  render={() => <WelcomePage />}
                />

                <Route exact path="/recover" render={() => <RecoverPage />} />

                <Route
                  exact={true}
                  path="/page/passage-new"
                  render={() =>
                    !appState.isAuth ? (
                      <Redirect to="/sign-in" />
                    ) : (
                      <NewPassage />
                    )
                  }
                />
                <Route
                  exact={true}
                  path="/page/passage/:id"
                  render={() =>
                    !appState.isAuth ? (
                      <Redirect to="/sign-in" />
                    ) : (
                      <PassageDetail />
                    )
                  }
                />

                <Route
                  exact
                  path="/page/my-account"
                  render={() => {
                    return !appState.isAuth ? (
                      <Redirect to="/sign-in" />
                    ) : (
                      <Account />
                    );
                  }}
                />
                <Route
                  exact
                  path="/page/my-account-change"
                  render={() => {
                    return !appState.isAuth ? (
                      <Redirect to="/sign-in" />
                    ) : (
                      <AccountChange />
                    );
                  }}
                />

                <Route
                  exact
                  path="/page/help/:id?"
                  render={() => {
                    return !appState.isAuth ? (
                      <Redirect to="/sign-in" />
                    ) : (
                      <HelpPage />
                    );
                  }}
                />
                <Route
                  exact
                  path="/page/new-help/:ticket_id/:type_id?"
                  render={() => {
                    return !appState.isAuth ? (
                      <Redirect to="/sign-in" />
                    ) : (
                      <HelpNewPage />
                    );
                  }}
                />
                <Route
                  path="/page/cars/:id"
                  exact={true}
                  render={() => {
                    return !appState.isAuth ? (
                      <Redirect to="/sign-in" />
                    ) : (
                      <CarPage />
                    );
                  }}
                />
                <Route
                  path="/page/cars"
                  exact={true}
                  render={() => {
                    return !appState.isAuth ? (
                      <Redirect to="/sign-in" />
                    ) : (
                      <CarsPage />
                    );
                  }}
                />
                <Route
                  path="/page/passages"
                  render={() => {
                    return !appState.isAuth ? (
                      <Redirect to="/sign-in" />
                    ) : (
                      <ListPassage />
                    );
                  }}
                  exact={true}
                />

                <Route path="/" exact render={() => <AppAuthRedirect />} />
              </IonRouterOutlet>
            </IonSplitPane>
          </ApolloProvider>
        </AppContext.Provider>
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
